module.exports = __webpack_public_path__ + "img/camera-icon.849ccb63.png";